<template>
	<NumberChip
		:label="label"
		:number="number"
		:is-highlighted="isHighlighted"
		:scheme="scheme"
	/>
</template>

<script>
import { GoalType } from "@teaming/common-enums";
import { NumberChip, NumberChipScheme } from "@teaming/common-ui";

export default {
	name: "GoalCountChip",
	components: {
		NumberChip,
	},
	props: {
		goalType: {
			type: String,
			required: true,
			validator( value ) {
				return GoalType.includes( value );
			},
		},
		count: {
			type: Number,
			required: true,
		},
		isSelected: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		label() {
			const { $t, } = this;
			const labelMap = new Map( [
				[ GoalType.ACTIVE, $t( "common-gokr.components.GoalCountChip.activeLabel" ), ],
				[ GoalType.DRAFT, $t( "common-gokr.components.GoalCountChip.futureLabel" ), ],
				[ GoalType.ARCHIVED, $t( "common-gokr.components.GoalCountChip.archivedLabel" ), ],
			] );
			return labelMap.get( this.goalType );
		},
		number() {
			const { $t, } = this;
			if ( this.count < 0 ) {
				return $t( "common-gokr.components.GoalCountChip.unknownLabel" );
			}
			return this.count;
		},
		isHighlighted() {
			return this.isSelected;
		},
		scheme() {
			return this.isSelected ?
				NumberChipScheme.BLUE :
				NumberChipScheme.MONOCHROME;
		},
	},
};
</script>

<style lang="scss" scoped></style>
